module.exports = __webpack_public_path__ + "media/components/country-flag/static/es-pv-eaa08b5ff8a120095d1f3b2522aaf998.svg";